<template>
  <v-card rounded="lg" variant="outlined" class="overflow-hidden">
    <v-responsive :aspect-ratio="16 / 9" class="position-relative bg-black">
      <!-- Poster + spinner on top via z-index, kept in DOM (opacity toggle) — no removal flash -->
      <div :class="['position-absolute w-100 h-100 d-flex align-center justify-center iframe-poster', { 'iframe-poster-hidden': ready }]">
        <v-img :src="poster" cover class="w-100 h-100 position-absolute" />
        <v-progress-circular indeterminate color="brand-color" size="32" width="2" class="position-relative" />
      </div>
      <!-- iframe loads silently underneath; poster only hides once it's actually ready to show -->
      <iframe :src="src" width="100%" height="100%" frameborder="0" allowfullscreen
        allow="autoplay; fullscreen; clipboard-write" class="iframe-embed" :class="{ 'iframe-visible': loaded }"
        @load="onLoad" />
    </v-responsive>
  </v-card>
</template>

<script>
export default {
  name: 'VideoEmbed',
  props: {
    src: { type: String, required: true },
    poster: { type: String, required: true }
  },
  data() {
    return {
      loaded: false,  // iframe @load fired - start fade in
      ready: false    // fade complete - remove poster
    }
  },
  methods: {
    onLoad() {
      this.loaded = true
      setTimeout(() => {
        this.ready = true
      }, 2500)
    }
  }
}
</script>

<style scoped>
.iframe-poster {
  z-index: 1;
  transition: opacity 0.4s ease;
}

.iframe-poster-hidden {
  opacity: 0;
  pointer-events: none;
}

.iframe-embed {
  opacity: 0;
  transition: opacity 0.4s ease
}

.iframe-visible {
  opacity: 1
}
</style>
